import { useMemo } from "react";
import { getBalances } from "../../utilities/getAccountGroupsV4";
import useGetAccountGroupsForTimeFrameV4 from "../useGetAccountGroupForTimeFrameV4";
export default function useGetBalancesV4(groupId, timeFrame, customTimeFrame, clientId, authConfig) {
    const query = useGetAccountGroupsForTimeFrameV4(groupId, timeFrame, customTimeFrame, clientId, authConfig);
    const balances = useMemo(() => query.data === undefined
        ? undefined
        : getBalances(query.data.dateRangePoints), [query.data]);
    const result = useMemo(() => {
        if (query.isLoading || query.hasError) {
            return query;
        }
        if (balances === undefined) {
            return {
                data: undefined,
                isLoading: false,
                hasError: true,
                error: new Error("Unknown error"),
            };
        }
        return { data: balances, isLoading: false, hasError: false };
    }, [balances, query]);
    return result;
}
//# sourceMappingURL=useGetBalancesV4.js.map